import * as React from 'react'
import { FC, useCallback } from 'react'
import TableWrapper from '../../../../../components/table-wrapper/table-wrapper'
import { Form, Pagination, Table } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { columns as baseColumns } from './constants/columns'
import { setEditing } from '../../../../../helpers/tables/set-editing'
import useEndpointQueryParams, {
    DeserializeFilters,
} from '../../../../../hooks/table-pages/use-endpoint-query-parameters'
import { EndpointQueryParameters, Filters } from '../../../../../types/strapi/strapi'
import useTablePagination from '../../../../../hooks/table-pages/use-table-pagination'
import { ReceiptStatus } from '../../../../../types/api/receipt'
import {
    useGetReceiptPositionsQuery,
    useUpdateReceiptPositionMutation,
} from '../../../../../store/api/receipt-positions-api'
import ReceiptPosition from '../../../../../types/api/receipt-position'
import FiltersForm from './components/filters-form/filters-form'
import qs from 'qs'
import FormValues from './components/filters-form/types/form-values'
import { buildFilters } from './helpers/build-filters'
import { EditableCell } from '../../../../../components/editable-cell/editable-cell'
import useErrorModal from '../../../../../hooks/api/use-error-modal'
import Accept from './components/accept/accept'

interface ReceiptsProps {
    actions?: boolean
    receiptStatusFilters?: ReceiptStatus[]
    positionFilters?: Filters
    sort?: string[]
}

const Receipts: FC<ReceiptsProps> = ({
    receiptStatusFilters,
    positionFilters,
    sort = ['updatedAt:desc'],
    actions = false,
}) => {
    const [form] = Form.useForm()
    const deserializeFilters: DeserializeFilters = filtersString => {
        const formValues = qs.parse(filtersString) as Partial<FormValues>
        return buildFilters(formValues, receiptStatusFilters, positionFilters)
    }

    const params = useEndpointQueryParams({ deserializeFilters })
    const positionsParams: EndpointQueryParameters = {
        populate: {
            receipt: { populate: { supplier: true } },
            material: { populate: { material_type: true } },
            initiator: true,
            unit: true,
        },
        pagination: params.pagination,
        filters: params.filters,
        sort: sort,
    }

    const { data, isLoading } = useGetReceiptPositionsQuery(positionsParams)
    const pagination = useTablePagination(params, data)
    const [updateReceiptPosition, updateState] = useUpdateReceiptPositionMutation()

    useErrorModal(updateState, 'Не удалось сохранить метраж')

    const onSaveAmount = async (record: ReceiptPosition, [, value]: [string, number]) => {
        if (value == null || value === record.amount) return
        await updateReceiptPosition({ docId: record.documentId, body: { data: { amount: value } } })
    }

    const columns: ColumnsType<ReceiptPosition> = [
        ...(actions ? setEditing<ReceiptPosition>(baseColumns, onSaveAmount) : baseColumns),
        {
            title: 'Действия',
            fixed: 'right',
            width: 80,
            render: (_, record) => (actions ? <Accept documentId={record.documentId} /> : null),
        },
    ]

    const tableFooter = useCallback(
        () => <Pagination {...pagination} size='small' align='end' />,
        [pagination]
    )

    return (
        <TableWrapper style={{ flex: 'auto' }} currentTableHeight={75}>
            <Form form={form} component={false}>
                <Table
                    bordered
                    columns={columns}
                    dataSource={data?.data || []}
                    components={actions ? { body: { cell: EditableCell } } : undefined}
                    pagination={false}
                    footer={tableFooter}
                    loading={isLoading}
                    rowKey={'documentId'}
                    summary={() => (
                        <Table.Summary fixed={'top'}>
                            <FiltersForm />
                        </Table.Summary>
                    )}
                />
            </Form>
        </TableWrapper>
    )
}

export default Receipts
